class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    if (this.dataset.openOnHover === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onMouseEnter() {
    clearTimeout(this.hoverCloseTimeout);
    this.mainDetailsToggle.setAttribute('open', '');
  }

  onMouseLeave() {
    this.hoverCloseTimeout = setTimeout(() => {
      this.close();
    }, 250);
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.alignMegaMenuContent();
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  alignMegaMenuContent() {
    const list = this.content.querySelector('.mega-menu__list--condensed');
    if (!list) return;

    const summary = this.mainDetailsToggle.querySelector('summary');

    // El offset se mide contra el contenedor directo de la lista (no contra
    // .mega-menu__content) para que el padding del page-width y la columna de
    // imágenes del megamenú no se cuenten dos veces.
    const container = list.parentElement || this.content;
    list.style.marginLeft = '0px';

    const containerRect = container.getBoundingClientRect();
    const summaryRect = summary.getBoundingClientRect();

    const maxOffset = Math.max(containerRect.width - list.offsetWidth, 0);
    const offset = Math.min(Math.max(summaryRect.left - containerRect.left, 0), maxOffset);

    list.style.marginLeft = `${offset}px`;
  }
}

customElements.define('header-menu', HeaderMenu);
